<template>
  <button
    v-on="listeners"
    v-bind="attrs"
    :type="type"
    :class="[custom, sizeClasses, modeClasses, isLoading, { disabled: disabled, 'has-group': group }]"
    :disabled="disabled"
    class="cbutton">
    <span class="flex items-center">
      <base-icon
        class="hidden md:block mr-2"
        :name="icon"
        size="sm"
        v-if="forceIcon"
      />
      <base-icon
        class="block md:hidden"
        :name="icon"
      />
      <span class="hidden md:block">{{ text }}</span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'base-button-responsive',
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'button'
    },
    text: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'md'
    },
    icon: {
      type: String,
      default: 'none'
    },
    forceIcon: {
      type: Boolean,
      default: false
    },
    custom: {
      type: [String, Object],
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    group: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners
      }
    },
    attrs: function () {
      return {
        ...this.$attrs
      }
    },
    isLoading: function () {
      return { 'loader-in-element': this.loading }
    },
    sizeClasses: function () {
      return {
        'w-12 md:w-auto h-12 md:h-8 md:px-4': this.size === 'xs',
        'w-12 md:w-auto h-12 md:h-10 md:px-6': this.size === 'md'
      }
    },
    modeClasses: function () {
      return {
        'cbutton--primary': this.mode === 'primary',
        'cbutton--staticprimary': this.mode === 'staticprimary',
        'cbutton--secondary': this.mode === 'secondary',
        'cbutton--prim-phantom': this.mode === 'primary-phantom',
        'cbutton--staticprim-phantom': this.mode === 'staticprimary-phantom',
        'cbutton--sec-phantom': this.mode === 'secondary-phantom',
        'cbutton--prim-line': this.mode === 'primary-line',
        'cbutton--tools': this.mode === 'tools',
        'cbutton--core': this.mode === 'core',
        'cbutton--sec-phantom-blue': this.mode === 'secondary-phantom-blue',
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .cbutton {
    @apply flex items-center justify-center space-x-1 text-sm font-semibold rounded-full md:rounded focus:outline-none transition-colors duration-300;
    &.cbutton--primary {
      @apply text-white bg-primary;
      &:focus-visible, &:hover {
        @apply bg-primary-500;
      }
      &:active:not(.disabled) {
        @apply bg-primary-800;
      }
    }
    &.cbutton--staticprimary {
      @apply text-white bg-staticprimary;
      &:focus-visible, &:hover {
        @apply bg-staticprimary-500;
      }
      &:active:not(.disabled) {
        @apply bg-staticprimary-800;
      }
    }
    &.cbutton--prim-line {
      @apply  border-2 border-solid bg-white dark:bg-darkblue text-primary border-primary;
      &:focus-visible, &:hover {
        @apply bg-primary-50 text-primary dark:bg-darkblue-600 dark:text-white;
      }
      &:active:not(.disabled) {
        @apply bg-primary text-white dark:text-white;
      }
    }
    &.cbutton--tools {
      @apply text-white;
      &:focus-visible, &:hover {
        @apply bg-secondary-900 dark:bg-darkblue;
      }
      &:active:not(.disabled) {
        @apply bg-secondary text-white dark:bg-darkblue;
      }
    }
    &.cbutton--core {
      @apply bg-white dark:bg-darkblue text-secondary dark:text-darkblue-200;
      &:focus-visible, &:hover {  
        @apply bg-primary-50 text-primary dark:bg-darkblue-600 dark:text-primary;
      }
      &:active:not(.disabled) {
        @apply bg-primary-100 text-primary;
      }
    }
    &.cbutton--secondary {
      @apply text-white bg-secondary dark:bg-darkblue-600;
      &:focus-visible, &:hover {
        @apply bg-secondary-500 dark:bg-darkblue-500;
      }
      &:active:not(.disabled) {
        @apply bg-secondary-800 dark:bg-darkblue;
      }
    }
    &.cbutton--prim-phantom {
      @apply bg-primary-50 dark:bg-darkblue text-primary;
      &:focus-visible, &:hover {
        @apply bg-primary-100 text-primary-500 dark:text-white dark:bg-primary-500;
      }
    }
    &.cbutton--staticprim-phantom {
      @apply bg-staticprimary-50 dark:bg-staticdarkblue text-staticprimary;
      &:focus-visible, &:hover {
        @apply bg-staticprimary-100 text-staticprimary-500 dark:text-white dark:bg-staticprimary-500;
      }
    }
    &.cbutton--sec-phantom {
      @apply bg-secondary-50 dark:bg-darkblue-600 text-secondary dark:text-darkblue-300;
      &:focus-visible, &:hover {
        @apply text-secondary-500 bg-secondary-100 dark:bg-darkblue-500 dark:text-darkblue-200;
      }
    }
    &.cbutton--sec-phantom-blue {
      @apply bg-secondary-50 dark:bg-darkblue-600 text-secondary dark:text-darkblue-100;
      &:focus-visible, &:hover {
        @apply text-white bg-primary-600 dark:text-white dark:bg-primary-600;
      }
    }
    &:active:not(.disabled) {
      transform: scale(0.96);
    }
    &.disabled {
      cursor: not-allowed;
    }
  }
</style>
